// ISSUE-1041 R4. One rule for the House rules field: when Save is on, what it
// shows, and the commissionerPreamble value to send to /pool/update.
//
// The server trims and caps at 2,000 characters too (postPoolUpdateHandler,
// VALIDATION_ERROR reason commissionerPreamble). null is sent to clear,
// because the request schema refuses an empty string.

export const HOUSE_RULES_LABEL = "House rules";
export const HOUSE_RULES_HINT =
  "Your own rules, shown above the ones written from your settings. Everyone in the pool can read them. Leave it empty to remove them.";
export const HOUSE_RULES_SAVE_LABEL = "Save house rules";
export const HOUSE_RULES_MAX_LENGTH = 2000;
export const HOUSE_RULES_TOO_LONG_ERROR =
  "Keep house rules to 2,000 characters or fewer.";

export type typeHouseRulesFieldState = {
  isSaveEnabled: boolean;
  error: string | null;
  /** The value to send when isSaveEnabled is true. */
  commissionerPreamble: string | null;
};

export function resolveHouseRulesFieldState(input: {
  draft: string;
  savedPreamble: string | null;
}): typeHouseRulesFieldState {
  const trimmed = input.draft.trim();
  if (trimmed.length > HOUSE_RULES_MAX_LENGTH) {
    return {
      isSaveEnabled: false,
      error: HOUSE_RULES_TOO_LONG_ERROR,
      commissionerPreamble: null,
    };
  }
  if (trimmed === (input.savedPreamble ?? "").trim()) {
    return { isSaveEnabled: false, error: null, commissionerPreamble: null };
  }
  return {
    isSaveEnabled: true,
    error: null,
    commissionerPreamble: trimmed === "" ? null : trimmed,
  };
}
